<!-- Nurse Assignment Dialog Container -->
<div class="nurse-assignment-container">
  <!-- Header Section -->
  <div class="assignment-header">
    <div class="header-content">
      <div class="header-left">
        <h1 class="assignment-title">
          <i class="pi pi-user-plus mr-3"></i>
          Assign Nurses
        </h1>
        <p class="assignment-subtitle">
          Assign professional nurses to {{ data?.clinic?.name }}
        </p>
      </div>
      <div class="header-right">
        <div class="clinic-status">
          <i class="pi pi-building status-icon"></i>
          {{ data?.clinic?.name }}
        </div>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <div class="assignment-content">
    <!-- Clinic Information Section -->
    <div class="content-section">
      <div class="section-header">
        <h2 class="section-title">
          <i class="pi pi-info-circle mr-2"></i>
          Clinic Information
        </h2>
      </div>
      
      <div class="clinic-info-grid">
        <div class="info-card">
          <div class="info-label">Clinic Name</div>
          <div class="info-value">{{ data?.clinic?.name }}</div>
        </div>
        
        <div class="info-card">
          <div class="info-label">Clinic ID</div>
          <div class="info-value">{{ data?.clinic?.id }}</div>
        </div>
        
        <div class="info-card">
          <div class="info-label">Professional Nurse</div>
          <div class="info-value">{{ data?.clinic?.professional_nurse || 'Not Assigned' }}</div>
        </div>
        
        <div class="info-card">
          <div class="info-label">Contact Number</div>
          <div class="info-value">{{ data?.clinic?.contact_number || 'Not Available' }}</div>
        </div>
      </div>
    </div>

    <!-- Nurse Assignment Section -->
    <div class="content-section">
      <div class="section-header">
        <h2 class="section-title">
          <i class="pi pi-users mr-2"></i>
          Nurse Selection
        </h2>
        <div class="nurses-count">{{ nurses.length || 0 }} nurse(s) available</div>
      </div>
      
      <form [formGroup]="nurseAssignmentForm" (ngSubmit)="onSubmit()" class="assignment-form">
        <div class="form-container">
          <div class="form-field">
            <label class="form-label">
              <i class="pi pi-user mr-2"></i>
              Select Nurses
            </label>
            <p-multiSelect
              optionLabel="fullName"
              formControlName="user_id"
              optionValue="id"
              placeholder="Choose nurses to assign to this clinic..."
              styleClass="modern-multiselect"
              appendTo="body"
              [options]="nurses"
              [showClear]="true"
              [filter]="true"
              filterPlaceholder="Search nurses..."
            ></p-multiSelect>
            
            <div *ngIf="submitted && nurseAssignmentForm.get('user_id')?.errors" class="error-message">
              <p-message
                *ngIf="f && f['user_id'] && f['user_id'].errors && f['user_id'].errors['required']"
                severity="error"
                text="Please select at least one nurse to assign"
                styleClass="modern-message"
              ></p-message>
            </div>
          </div>

          <!-- Selected Nurses Preview -->
          <div class="selected-nurses" *ngIf="nurseAssignmentForm.get('user_id')?.value?.length > 0">
            <div class="preview-header">
              <h3 class="preview-title">
                <i class="pi pi-check-circle mr-2"></i>
                Selected Nurses ({{ nurseAssignmentForm.get('user_id')?.value?.length }})
              </h3>
            </div>
            
            <div class="nurses-list">
              <div class="nurse-item" *ngFor="let nurseId of nurseAssignmentForm.get('user_id')?.value">
                <div class="nurse-info">
                  <i class="pi pi-user nurse-icon"></i>
                  <span class="nurse-name">{{ getNurseName(nurseId) }}</span>
                </div>
                <button type="button" class="remove-btn" (click)="removeNurse(nurseId)">
                  <i class="pi pi-times"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- Action Buttons Section -->
    <div class="content-section action-section">
      <div class="action-buttons">
        <button type="button" class="action-btn secondary" (click)="closeDialog()">
          <i class="pi pi-times mr-2"></i>
          Cancel
        </button>
        <button 
          type="submit" 
          class="action-btn primary" 
          [disabled]="loading || !nurseAssignmentForm.valid"
          (click)="onSubmit()"
        >
          <i class="pi pi-check mr-2" *ngIf="!loading"></i>
          <i class="pi pi-spinner pi-spin mr-2" *ngIf="loading"></i>
          {{ loading ? 'Assigning...' : 'Assign Nurses' }}
        </button>
      </div>
    </div>
  </div>
</div>
